import { useState, useRef } from 'react';
import { SearchableSelect } from '../../design-system';
import { useYardOptionsByClientQuery } from '../../hooks';
import { i18n } from '../../i18n';
import { useParams } from 'react-router-dom';

interface BelongsToFilterSelectsProps {
  country?: string;
  city?: string;
  handleChange: (obj: any) => void;
}

export const BelongsToFilterSelects: React.FC<BelongsToFilterSelectsProps> = ({
  country: defaultCountry = '',
  city: defaultCity = '',
  handleChange,
}: BelongsToFilterSelectsProps) => {
  const params = useParams();

  const [country, setCountry] = useState(defaultCountry);
  const [city, setCity] = useState(defaultCity);
  const [yardName, setYardName] = useState('');
  const yardId = useRef('');

  const { data: yardQuery } = useYardOptionsByClientQuery(
    ['yard-short', 'assigned-yards' + params.id],
    {
      user: { type: 'CLIENT_MANAGER' },
      clientId: params.code,
      country,
      city,
    },
  );

  const handleCountrySelect = (obj: any) => {
    const otherData: any = {};
    setCity('');
    setYardName('');

    setCountry(obj.label);

    const data = { country: obj.label, city: '', ...otherData };
    handleChange && handleChange(data);
  };

  const handleCitySelect = (obj: any) => {
    const otherData: any = {};
    setYardName('');

    setCity(obj.label);

    const data = { city: obj.label, ...otherData };
    handleChange && handleChange(data);
  };

  const handleYardSelect = (obj: any) => {
    const otherData: any = {};

    yardId.current = obj.id;
    setYardName(obj.label);

    const data = { yardId: obj.id, ...otherData };
    handleChange && handleChange(data);
  };

  return (
    <>
      <SearchableSelect
        selectedOptionLabel={country}
        label={i18n.t('label.country')}
        onSelect={handleCountrySelect}
        options={yardQuery.country}
        selectedAreasEqaul={{ key: 'id', keys: [country] }}
        withClearButton
      />
      <SearchableSelect
        selectedOptionLabel={city}
        label={i18n.t('label.city')}
        onSelect={handleCitySelect}
        options={yardQuery.city}
        selectedAreasEqaul={{ key: 'id', keys: [city] }}
        withClearButton
      />
      {false && (
        <SearchableSelect
          selectedOptionLabel={yardName}
          label={i18n.t('common.yard')}
          onSelect={handleYardSelect}
          options={yardQuery.yard}
          selectedAreasEqaul={{ key: 'id', keys: [yardName] }}
          withClearButton
        />
      )}
    </>
  );
};
